<template>
  <template v-if="recommenderType === 'pdp'">
    <TeaserSlider
      v-if="$flags.has('product_detail.recos.luigisbox') && isLuigisBoxPersonalizedConsentGiven"
      id="luigi_product_detail_recommender"
      class="my-8"
      :is-recommendation="true"
      :external-products="products?.product_detail?.items"
      :is-external="true"
      :reco-type="'product_detail'"
      image-load-type="lazy"
      :title="$t(titleMap['product_detail'])"
      :loading="loading"
      :product-id="props.productId"
    />

    <TeaserSlider
      v-if="$flags.has('product_detail_complements.recos.luigisbox') && isLuigisBoxPersonalizedConsentGiven"
      id="luigi_product_detail_complements_recommender"
      :is-recommendation="true"
      :external-products="products?.product_detail_complements?.items"
      :is-external="true"
      :reco-type="'product_detail_complements'"
      image-load-type="lazy"
      :title="$t(titleMap['product_detail_complements'])"
      :loading="loading"
      class="my-8"
      :product-id="props.productId"
    />
  </template>
  <template v-else>
    <TeaserSlider
      v-if="$flags.has('homepage.recos.luigisbox') && isLuigisBoxPersonalizedConsentGiven"
      id="luigi_homepage_personalized_recommender"
      :external-products="products?.homepage_personalized?.items"
      :is-external="true"
      :reco-type="'homepage_personalized'"
      image-load-type="lazy"
      :title="$t(titleMap['homepage_personalized'])"
      :title-level="2"
      title-class="text-left"
      :loading="loading"
      class="my-8"
    />
  </template>
</template>

<script lang="ts" setup>
import TeaserSlider from './TeaserSlider.vue';
import { useRecoSlider } from './useTeaserSlider/useRecoSlider';
import { useUsercentrics } from '~/composables/custom/useUsercentrics/useUsercentrics';

type RecommendationType = 'home' | 'pdp';

interface Props {
  productId?: string | null | undefined;
  recommenderType?: RecommendationType;
  fallbackCategory?: string | null;
}

const props = withDefaults(defineProps<Props>(), {
  productId: null,
  fallbackCategory: null,
  recommenderType: 'home',
});

const { $flags } = useNuxtApp();
const { isLuigisBoxPersonalizedConsentGiven } = useUsercentrics();

const { fetchRecommendations, products, loading } = useRecoSlider(props.recommenderType, props.productId as string);
const titleMap = {
  /* eslint-disable camelcase */
  homepage_personalized: 'Recommended for you',
  product_detail: 'Similar products',
  product_detail_complements: 'More recommendations for you',
  /* eslint-enable camelcase */
};

onBeforeMount(async () => {
  await fetchRecommendations(props.recommenderType, props.productId, props.fallbackCategory);
});
</script>
